// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"C6-z"};